import React from 'react';
import PropTypes from 'prop-types';
import { FixedSizeList as List } from 'react-window';
import AutoSizer from 'react-virtualized-auto-sizer';
import { useTranslator } from 'tradera-lang/translate';
import { getTranslatedAttributeValue } from 'tradera-components/attributes/attribute-helper';

const AttributeList = ({
    attributes,
    hideCheckbox = false,
    selected,
    setSelected,
    parameter,
    translateOptions
}) => {
    const { t } = useTranslator();

    const Row = ({ index, style }) => (
        <div
            className="d-flex list-group-item list-group-item-action px-0"
            style={style}>
            <span className="form-check form-check-sm form-check-round form-check-success flex-grow-1 my-0 px-2">
                <label
                    htmlFor={index + attributes[index].value}
                    className="form-check-label d-flex align-items-center w-100 h-100 pl-0 text-gray-600">
                    {translateOptions
                        ? getTranslatedAttributeValue(
                              parameter,
                              attributes[index].value,
                              t
                          )
                        : attributes[index].name
                        ? attributes[index].name
                        : attributes[index].value}
                </label>
                <input
                    className={`form-check-input position-static my-auto ${
                        hideCheckbox ? 'd-none' : ''
                    }`}
                    type="checkbox"
                    id={index + attributes[index].value}
                    name={parameter}
                    value={`${parameter}Selector`}
                    checked={selected.includes(attributes[index].value)}
                    onChange={() => {
                        setSelected(attributes[index].value);
                    }}
                />
            </span>
        </div>
    );

    return (
        <div className="h-100 w-100">
            {attributes.length > 0 ? (
                <AutoSizer>
                    {({ height, width }) => (
                        <List
                            className="list-group"
                            height={height}
                            itemCount={attributes.length}
                            itemSize={42}
                            width={width}>
                            {Row}
                        </List>
                    )}
                </AutoSizer>
            ) : (
                <div className="list-group w-100">
                    <div className="d-flex list-group-item list-group-item-action">
                        Inga resultat
                    </div>
                </div>
            )}
        </div>
    );
};

AttributeList.defaultProps = {
    selected: []
};

AttributeList.propTypes = {
    attributes: PropTypes.array,
    selected: PropTypes.array,
    setSelected: PropTypes.func
};

export default AttributeList;
